<template>
  <div class="mm-page-main"  v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO和門店'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="page-header">
      <div class="page-title">貨幣管理</div>

    </div>

    <div v-if="stores.length>0" class="mm-tabs">
      <div class="mm-tabsulbox">
        <div @click="tableft" class="tabsleftico"><i class="el-icon-arrow-left"></i></div>
        <ul :style="transform" class="mm-tabs-card">
          <li @click.stop="changestore(store.id)" :class="{active:store_id == store.id}" v-for="(store,index) in stores" :key="index">{{store.name}}</li>
        </ul>
        <div @click="tabright" class="tabsrightico"><i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="mm-tabs-content">
        <div class="mm-tab-hedaer">
          <div class="mm-tab-title">
            <h3>現金</h3>
          </div>

        </div>
        <div class="pagetablebox">
          <el-table empty-text="暫無數據" :data="currencydata0" border :header-cell-style="{background:'#FAFAFA'}">
            <el-table-column prop="name" label="貨幣" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">貨幣</div>
                <div style="display: flex; align-items: center; ">
                  <div><img style="display: block; width: 30px; height: 30px;" :src="apiurl+scope.row.thumb"></div>
                  <div style="margin-left: 10px;">{{scope.row.short_name}}</div>
                  <div style="margin-left: 10px;">{{scope.row.name}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="type1" label="業務" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">業務</div>
                <el-switch @change="changetype1($event,scope.row.id,0)" v-model="scope.row.type1" active-text="啟用" inactive-text="禁用"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="type2" label="大銀幕" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">大銀幕</div>
                <el-switch @change="changetype2($event,scope.row.id,0)" v-model="scope.row.type2" active-text="啟用" inactive-text="禁用"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="type3" label="使用除法" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">使用除法</div>
                <el-switch @change="changetype3($event,scope.row.id,0)" v-model="scope.row.type3" active-text="啟用" inactive-text="禁用"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="type4" label="計算成本" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">計算成本</div>
                <el-switch @change="changetype4($event,scope.row.id,0)" v-model="scope.row.type4" active-text="自動" inactive-text="手動"></el-switch>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="defaultrate" label="參考匯率" align="center">
							<template slot-scope="scope">
								<div class="phonecel">參考匯率</div>
								<div style="display: flex; align-items: center; justify-content: center;">
									<el-input @change="changerate0(scope.row.id,scope.row.defaultrate)" v-if="scope.row.enedit" v-model="scope.row.defaultrate"></el-input>
									<div v-else="!scope.row.enedit">{{scope.row.defaultrate}}</div>
									<div @click="enedit0(scope.row.id)" style="margin-left: 10px; cursor: pointer;"><i class="el-icon-edit-outline"></i></div>
								</div>
							</template>
						</el-table-column> -->
          </el-table>
        </div>
      </div>
      <div class="mm-tabs-content">
        <div class="mm-tab-hedaer">
          <div class="mm-tab-title">
            <h3>匯款</h3>
          </div>

        </div>
        <div class="pagetablebox">
          <el-table empty-text="暫無數據" :data="currencydata1" border :header-cell-style="{background:'#FAFAFA'}">
            <el-table-column prop="name" label="貨幣" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">貨幣</div>
                <div style="display: flex; align-items: center;">
                  <div><img style="display: block; width: 30px; height: 30px;" :src="apiurl+scope.row.thumb"></div>
                  <div style="margin-left: 10px;">{{scope.row.short_name}}</div>
                  <div style="margin-left: 10px;">{{scope.row.name}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="type1" label="業務" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">業務</div>
                <el-switch @change="changetype1($event,scope.row.id,1)" v-model="scope.row.type1" active-text="啟用" inactive-text="禁用"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="type2" label="大銀幕" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">大銀幕</div>
                <el-switch @change="changetype2($event,scope.row.id,1)" v-model="scope.row.type2" active-text="啟用" inactive-text="禁用"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="type3" label="使用除法" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">使用除法</div>
                <el-switch @change="changetype3($event,scope.row.id,1)" v-model="scope.row.type3" active-text="啟用" inactive-text="禁用"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="type4" label="計算成本" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">計算成本</div>
                <el-switch @change="changetype4($event,scope.row.id,1)" v-model="scope.row.type4" active-text="自動" inactive-text="手動"></el-switch>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="defaultrate" label="參考匯率" align="center">
              <template slot-scope="scope">
                <div class="phonecel">參考匯率</div>
                <div style="display: flex; align-items: center; justify-content: center;">
                  <el-input @change="changerate1(scope.row.id,scope.row.defaultrate)" v-if="scope.row.enedit" v-model="scope.row.defaultrate"></el-input>
                  <div v-else="!scope.row.enedit">{{scope.row.defaultrate}}</div>
                  <div @click="enedit1(scope.row.id)" style="margin-left: 10px; cursor: pointer;"><i class="el-icon-edit-outline"></i></div>
                </div>
              </template>

            </el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {

  data () {
    return {
      mso_id:0,
      loading: false,
      store_id: 0,
      stores: [],
      currencydata0: [],
      currencydata1: [],
      transform: '',
      transformnum: 0,
    }
  },
  methods: {
    tableft () {
      let num = this.transformnum - 1;
      if (num >= 0) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }

    },
    tabright () {
      let num = this.transformnum + 1;
      if (num < this.stores.length - 1) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }
    },
    enedit0 (id) {
      let currencydata0 = this.currencydata0;
      currencydata0.map((v) => {
        if (v.id == id) {
          v.enedit = 1;
          this.currencydata0 = currencydata0;

          return;
        }

      })


    },
    changerate0 (currency_id, defaultrate) {
      let store_id = this.store_id;
      let currencydata0 = this.currencydata0;
      this.post('/api/currency/changedefaultrate', {
        store_id: store_id,
        currency_id: currency_id,
        type0: 0,
        defaultrate: defaultrate
      }).then((res) => {
        
        currencydata0.map((v) => {
          if (v.id == currency_id) {
            v.enedit = 0;
            this.currencydata0 = currencydata0;
            return;
          }

        })
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },
    enedit1 (id) {
      let currencydata1 = this.currencydata1;
      currencydata1.map((v) => {
        if (v.id == id) {
          v.enedit = 1;
          this.currencydata1 = currencydata1;

          return;
        }

      })


    },
    changerate1 (currency_id, defaultrate) {
      let store_id = this.store_id;
      let currencydata1 = this.currencydata1;
      this.post('/api/currency/changedefaultrate', {
        store_id: store_id,
        currency_id: currency_id,
        type0: 1,
        defaultrate: defaultrate
      }).then((res) => {
        currencydata1.map((v) => {
          if (v.id == currency_id) {
            v.enedit = 0;
            this.currencydata1 = currencydata1;

            return;
          }

        })
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },
    changetype1 ($event, currency_id, type0) {
      let store_id = this.store_id;
      let staff_id = sessionStorage.getItem('staff_id');
      let type1 = $event;
      this.loading = true;
      this.post('/api/currency/changetype', {
        staff_id: staff_id,
        store_id: store_id,
        currency_id: currency_id,
        type0: type0,
        type1: type1
      }).then((res) => {

        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })

    },
    changetype2 ($event, currency_id, type0) {
      let store_id = this.store_id;
      let staff_id = sessionStorage.getItem('staff_id');
      let type2 = $event;
      this.loading = true;
      this.post('/api/currency/changetype', {
        staff_id: staff_id,
        store_id: store_id,
        currency_id: currency_id,
        type0: type0,
        type2: type2
      }).then((res) => {

        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },
    changetype3 ($event, currency_id, type0) {
      let store_id = this.store_id;
      let staff_id = sessionStorage.getItem('staff_id');
      let type3 = $event;
      this.loading = true;
      this.post('/api/currency/changetype', {
        staff_id: staff_id,
        store_id: store_id,
        currency_id: currency_id,
        type0: type0,
        type3: type3
      }).then((res) => {

        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },

    changetype4 ($event, currency_id, type0) {
      let staff_id = sessionStorage.getItem('staff_id');
      let store_id = this.store_id;
      let type4 = $event;
      this.loading = true;
      this.post('/api/currency/changetype', {
        staff_id: staff_id,
        store_id: store_id,
        currency_id: currency_id,
        type0: type0,
        type4: type4
      }).then((res) => {

        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },

    getcurrency0 () {
      this.loading = true;
      this.post('/api/currency/getcurrency', {
        store_id: this.store_id,
        type0: 0
      }).then((res) => {
        res.map((v) => {
          if (v.type1 == 0) {
            v.type1 = false;

          } else if (v.type1 == 1) {
            v.type1 = true;
          }
          if (v.type2 == 0) {
            v.type2 = false;

          } else if (v.type2 == 1) {
            v.type2 = true;
          }
          if (v.type3 == 0) {
            v.type3 = false;

          } else if (v.type3 == 1) {
            v.type3 = true;
          }

          if (v.type4 == 0) {
            v.type4 = false;

          } else if (v.type4 == 1) {
            v.type4 = true;
          }
        })

        this.currencydata0 = res;
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      }).then(() => {

      })
    },
    getcurrency1 () {
      this.loading = true;
      this.post('/api/currency/getcurrency', {
        store_id: this.store_id,
        type0: 1
      }).then((res) => {
        res.map((v) => {
          if (v.type1 == 0) {
            v.type1 = false;

          } else if (v.type1 == 1) {
            v.type1 = true;
          }
          if (v.type2 == 0) {
            v.type2 = false;

          } else if (v.type2 == 1) {
            v.type2 = true;
          }
          if (v.type3 == 0) {
            v.type3 = false;

          } else if (v.type3 == 1) {
            v.type3 = true;
          }
        })

        this.currencydata1 = res;
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      }).then(() => {

      })
    },

    changestore (store_id) {
      this.store_id = store_id;
      this.getcurrency0();
      this.getcurrency1();
    },

    gotoruter (name) {
      this.$router.push(name)
    },
    getstore () {

      this.loading = true;
      this.post('/api/currency/index', {

      }).then((res) => {
        // if (res.length > 0) {
        // 	this.store_id = res[0].id;
        // }
        this.stores = res;
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      }).then(() => {
        this.getcurrency0();
        this.getcurrency1();
      })


    },
  },
  created () {
    this.mso_id = sessionStorage.getItem('mso_id');
    this.getstore();
  }
}
</script>

<style scoped>
</style>
